import { supabase } from './supabase.js';

export const IMAGE_STORAGE_PROVIDER = (
  import.meta.env.VITE_IMAGE_STORAGE_PROVIDER || 'disabled'
).trim().toLowerCase();

export const IMAGE_STORAGE_BUCKET = (
  import.meta.env.VITE_IMAGE_STORAGE_BUCKET || 'visit-photos'
).trim();

export function imageStorageEnabled() {
  return IMAGE_STORAGE_PROVIDER === 'supabase';
}

export async function uploadImageFile(file, path, { upsert = false } = {}) {
  if (!imageStorageEnabled()) {
    throw new Error('Penyimpanan gambar belum dikonfigurasi. Data klinik tetap dapat digunakan tanpa upload gambar.');
  }
  if (!supabase) throw new Error('Supabase belum dikonfigurasi.');

  const { error } = await supabase.storage
    .from(IMAGE_STORAGE_BUCKET)
    .upload(path, file, { contentType: file.type, upsert });
  if (error) throw new Error(error.message);

  const { data } = supabase.storage.from(IMAGE_STORAGE_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}
